define.alias("shared/helpers/format-profile-categorization-value", "preview-grid/helpers/format-profile-categorization-value");